import { InjectionToken } from '@angular/core';

import { DialogConfig } from '../services/dialog.service';

export const DIALOG_R_DATA = new InjectionToken<DialogConfig>('DIALOG_R_DATA');